import { ChangedEvent } from 'gojs';

const INITIAL_LAYOUT_TRANSACTION_NAME = 'Initial Layout';

// This event is emitted after InitialLayoutCompleted, which is part of gojs internal implementation
// It's not connected to user interaction
export const isInitialLayoutTransactionEvent = ({ change, oldValue }: ChangedEvent): boolean =>
  change === ChangedEvent.Transaction && oldValue === INITIAL_LAYOUT_TRANSACTION_NAME;
